import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { whenOfficeReady } from './lib/office';
import './styles.css';

// React must not mount until Office.js has initialised, or Office.context is
// undefined and the roaming-settings session restore silently misses.
whenOfficeReady().then(() => {
  const el = document.getElementById('root');
  if (!el) throw new Error('root element missing');
  createRoot(el).render(<StrictMode><App /></StrictMode>);
});
